import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import _ from "lodash";

import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import * as modalActions from "../../_shared/modal/modalActions";

const mapDispatchToProps = dispatch => ({
  onOK: () => {
    dispatch(modalActions.closeModal());
  },
});

export const parseLinkedProject = (projectStr) => {
  // Guard against null/undefined/non-string input
  if (!projectStr || typeof projectStr !== 'string') {
    return { projectName: '', categoryName: '' };
  }
  const categoryDelimiter = ' | Category: ';
  const delimiterIndex = projectStr.indexOf(categoryDelimiter);
  if (delimiterIndex === -1) {
    return { projectName: projectStr, categoryName: '' };
  }
  const raw = projectStr.substring(0, delimiterIndex);
  const projectName = raw.endsWith(')') ? raw : raw + ')';
  let categoryName = projectStr.substring(delimiterIndex + categoryDelimiter.length);
  if (categoryName.endsWith(')')) {
    categoryName = categoryName.slice(0, -1);
  }
  return { projectName, categoryName };
};

export const AlreadyLinkedToAnotherProjectModalContent = ({ onOK, linkedProjects }) => {
  return (
    <Fragment>
      <DialogTitle id='responsive-dialog-title'>Cannot Edit Document</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This document cannot be edited as it is linked to another project. Please unlink it from project below:
        </DialogContentText>
        {linkedProjects && linkedProjects.length > 0 && (
          linkedProjects.map((project, index) => {
            const { projectName, categoryName } = parseLinkedProject(project);
            return (
              <DialogContentText key={index} style={{ marginTop: 8 }}>
                <strong>Linked to: </strong>{projectName}
                {categoryName && (
                  <>
                    <br />
                    <strong>Category: </strong>{categoryName}
                  </>
                )}
              </DialogContentText>
            );
          })
        )}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onOK} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Fragment>
  );
};

AlreadyLinkedToAnotherProjectModalContent.defaultProps = {
  onOK: _.noop,
  linkedProjects: [],
};

AlreadyLinkedToAnotherProjectModalContent.propTypes = {
  onOK: PropTypes.func,
  linkedProjects: PropTypes.arrayOf(PropTypes.string),
};

const reduxConnected = connect(
  null,
  mapDispatchToProps,
)(AlreadyLinkedToAnotherProjectModalContent);

export default withRouter(reduxConnected);
